/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'

import React from 'react'
import Grid from './grid'
import { Disclosures, Loading } from '../../twd'
import useTickers from './use-tickers'

export default () => {

    const {tickerData, status} = useTickers()

    return <React.Fragment>
    <div id="municipal-ticker" className="vertical-offset-sm"></div>
    <div data-name='municipals-ticker' className="container vertical-offset-sm" css={sectionCss}>
    <div className="row vertical-offset-sm"></div>

        <div className="row">
        <div className="col-xs-12">
            <h3 className="medium-header">Municipal Ticker</h3>
        </div>
        </div>

        <Loading status={status}>
        <div className="row">
        <div className="col-xs-12">
            <Grid rows={tickerData} />
        </div>
        </div>
        </Loading>

        <div className="row">
            <div className="col-md-12 col-xs-12 text-right">
                <Disclosures
                    dataName='municipals-ticker-disclosures-link'
                    html={DISCLOSURES}
                />
            </div>
        </div>
        <div className="row vertical-offset-sm"></div>
    </div>
    </React.Fragment>
}

const DISCLOSURES = `
<p>We are providing certain data supplied to us by
the Municipal Securities Rulemaking Board ("the Service") without warranties
or representations and on an "as is" basis.
WE HEREBY DISCLAIM ALL REPRESENTATIONS AND WARRANTIES (EXPRESS OR IMPLIED), INCLUDING,
BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE REGARDING
THE Service. You shall bear all risk, related costs and liability and be responsible
for your use of the Service.
We assume no responsibility for the consequences of any intentional or unintentional error,
omission, inaccuracy, incompleteness or untimeliness in or with respect to the Service.</p>

<p style="font-weight:bold">Real-Time Transaction Data Subscription Service</p>

<p>The Transaction data provided through the Real-Time Transaction Data Subscription Service
represents municipal securities transaction data made available by brokers,
dealers and municipal securities dealers to the MSRB and related information.
Such transaction data and/or related information may not exist for all municipal securities
and may not be required to be submitted to the MSRB for certain types of municipal securities transactions.
The MSRB does not review transaction data submitted by submitters for accuracy, completeness or any other purpose,
and does not warrant or guarantee the accuracy of any such transaction data and/or related information.</p>


<p style="font-weight:bold">Comprehensive Transaction Data Subscription Service</p>

<p>The Transaction data provided through the Comprehensive Transaction Data Subscription Service
represents trade reports for specific trade dates: (1) made available at approximately 6.00 a.m.
on the business day following trade date ("T+1"); (ii) made available five business days after that trade date ("T+5");
and (iii) made available 20 days after that trade date ("T+20"). Such transaction data and/or related information
may not exist for all municipal securities. The MSRB does not review the transaction data for accuracy,
completeness or any other purpose, and does not warrantor guarantee the accuracy of
any such transaction data and/or related information.</p>

<p>The MSRB, its officers, directors, employees, agents, consultants and licensors
shall not be liable of responsible to you or anyone else for any losses, injuries, damages, costs,
expenses or claims caused by, arising out of or relating to the following:
(a) acts, omissions, occurrences or contingencies beyond their control;
(b) service interruptions or performance failures, such as those that result from the use of telecommunications facilities
that are outside their control, including the internet;
(c) negligence, gross negligence or willful misconduct in procuring, compiling, interpreting, editing, writing reporting
or delivering any of the content and material;
(d) lost, stolen, late, corrupted, misdirected, failed, incomplete or delayed transmissions
by anyone using the Service, including, but not limited to, any technical malfunctions, human error, computer viruses,
lost data transmissions, omissions, interruptions, deletions, defects, hyperlink failures or line failures of any telephone network,
computer equipment, software or any combination thereof;
(e) damage to your computer systems, equipment, software, data or other tangible or intangible property resulting from
or sustained in connection with your use of the Service, and/or
(f) any disruption of business, lost sales or lost profits or any punitive, exemplary, indirect, special,
incidental or consequential damages associated or in connection with, resulting from or arising out of
any use of the Service or the content and material in the Service.
</p>

<p>The MSRB and its officers, directors, employees, agents consultants and licensors shall have not liability
in tort, contract or otherwise (and as permitted by law, product liability) to you or anyone else
for any reason associated or in connection with, resulting from or arising out of your use of the Service.
The MSRB, its officers, directors, employees, agents, consultants and licensors make, and have made,
no recommendations regarding any of the securities or other investment vehicles identified, referred to
or described in the Service.</p>

<p>The Service is reproduced by permission of the MSRB under a non-exclusive license.
The MSRB accepts no responsibility for the accuracy of the reproduction of the Service
or that such Service is current.</p>
`


// WEBPACK FOOTER //
// ./src/municipals/tickers/tickers.js